








































































































































import { Component, Vue, Watch, PropSync } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
import {
  home,
  moment,
  assessment,
  application,
  message,
  manage,
  teacherStudent,
  setting,
} from '@/router'
import { MessageController } from '@/services/request.service'
import { getSchoolInfo } from '@/utils/utils'
const Logo = require('@/assets/images/logo.svg')
const SmallLogo = require('@/assets/images/logo-small.svg')

@Component
export default class PCMenu extends Vue {
  @PropSync('fold', { default: false }) public collapsed!: boolean
  public menuKeys: Array<string> = []
  public menuOpenKeys: Array<string> = []
  public newMessage = 0

  @Watch('$route', { immediate: true })
  public onRouteChanged(to: any, from: any) {
    this.getMessage()
    // const routes = to.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
    // const menuKey = routes.filter(route => route.meta.menu)[0]?.meta?.routerName ?? ''
    // this.menuOpenKeys = routes[1] ? [routes[0].meta.routerName] : []
    // this.menuKeys = [menuKey]
  }

  public get subRoutes(): any {
    if (this.$store.state.routes && this.$store.state.routes.length) {
      return this.$store.state.routes[0].children.filter(child => !child.hidden)
    } else {
      return []
    }
  }

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get frameType(): string {
    return getSchoolInfo().frameType
  }

  public get roleType(): string {
    return this.$store.state.roleType
  }

  public get schoolId(): number {
    return getSchoolInfo().schoolId
  }

  public get menus(): Array<object> {
    return this.subRoutes
  }

  public get rootMenuOpenKeys(): Array<string> {
    const routes = Object.values(this.subRoutes) as any
    return routes.map(route => route.meta.routerName)
  }

  public get logo(): any {
    return this.$store.state.logo || Logo
  }

  public get smallLogo(): any {
    return this.$store.state.smallLogo || SmallLogo
  }

  public getMessage(): void {
    MessageController.hasUnRead()
      .then(res => {
        if (res.data) {
          this.newMessage = 1
        } else {
          this.newMessage = 0
        }
      })
      .catch(err => {
        console.error(err)
      })
  }

  public onOpenChange(openKeys): void {
    const latestOpenKey = openKeys.find(key => this.menuOpenKeys.indexOf(key) === -1)
    if (this.rootMenuOpenKeys.indexOf(latestOpenKey) === -1) {
      this.menuOpenKeys = openKeys
    } else {
      const children = this.subRoutes.filter(route => route.meta.routerName === latestOpenKey)[0]
        .children
      const childrenArray = children.map(child => child.meta.routerName)
      this.menuOpenKeys = latestOpenKey ? [latestOpenKey, ...childrenArray] : []
    }
  }

  public clickLeftMenu({ key }: { key: string }): void {
    this.$router.push({ name: key }).catch(err => {})
  }

  public calcType(name): string {
    const nameTypeList = {
      home: 'home',
      moment: 'file-text',
      assessment: 'sliders',
      application: 'appstore',
      manage: 'pie-chart',
      teacherStudent: 'pie-chart',
      setting: 'setting',
    }
    return nameTypeList[name]
  }
}
